import ROUTES from '../routes';
import AccountsList from "../hoc/accounts/list";
import Form from "../hoc/accounts/form";

const AccountsRoutes = {
  path: ROUTES.ACCOUNTS_LIST,
  element: <AccountsList />,
  children: [
    {
      path: ROUTES.ACCOUNTS_CREATE,
      element: <Form />,
    },
    {
      path: ROUTES.ACCOUNTS_EDIT,
      element: <Form />,
    },
  ],
};

export default AccountsRoutes;
